import React from 'react';
import {IconButton} from '@mui/material';

import {AddWhite} from '@icons/index';

interface SelectFileComponentProps {
  accept?: string;
  handleFileSelected?: (file: File) => void;
}

const SelectFileComponent = (props: SelectFileComponentProps) => {
  const {
    accept,
    handleFileSelected,
  } = props;

  const inputFileRef = React.useRef<HTMLInputElement | null>(null);

  return (
    <>
      <input
        type="file"
        accept={accept}
        ref={inputFileRef}
        style={{display: 'none'}}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (!file) return;

          handleFileSelected?.(file);
          e.currentTarget.value = '';
        }}/>
      <IconButton aria-label="small-square-text" centerRipple={false} onClick={() => inputFileRef.current?.click()}>
        <AddWhite/>
      </IconButton>
    </>
  );
};

export default SelectFileComponent;
